import React from "react";
import { Dialog, DialogContent } from "@mui/material";
import {
  Button,
  Iconography,
  IconographySizes,
} from "@hid-galaxy-ui/galaxy-react";
import RichTextView from "../../../../../../../common/components/RichTextView";
import { BenefitLogFile } from "./mockData";

type Props = {
  open: boolean;
  benefitName: string;
  comment: string;
  files: BenefitLogFile[];
  onFileClick: (file: BenefitLogFile) => void;
  onClose: () => void;
};

const ViewCommentsModal: React.FC<Props> = ({
  open,
  benefitName,
  comment,
  files,
  onFileClick,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "6px",
          boxShadow: "0px 12px 32px rgba(15, 23, 42, 0.18)",
          maxWidth: 560,
        },
      }}
    >
      <div className="bl-view-modal">
        <header className="bl-view-modal-header">
          <div>
            <h3>Comments / Files</h3>
            <p className="bl-view-modal-subtitle">{benefitName}</p>
          </div>
          <button
            type="button"
            className="bl-view-modal-close"
            onClick={onClose}
            aria-label="Close"
          >
            <Iconography icon="xmark" size={IconographySizes.Medium} />
          </button>
        </header>

        <DialogContent className="bl-view-modal-content">
          <label className="bl-field-label">Description</label>
          <RichTextView html={comment} className="bl-view-description" />

          {files.length > 0 ? (
            <>
              <label className="bl-field-label bl-view-files-label">
                Files ({files.length})
              </label>
              <ul className="bl-view-files-list">
                {files.map((file) => (
                  <li key={file.id}>
                    <button
                      type="button"
                      className="bl-view-file-link"
                      onClick={() => onFileClick(file)}
                    >
                      {file.name}
                    </button>
                  </li>
                ))}
              </ul>
            </>
          ) : null}
        </DialogContent>

        <footer className="bl-view-modal-footer">
          <Button variant="primary" label="CLOSE" onClick={onClose} />
        </footer>
      </div>
    </Dialog>
  );
};

export default ViewCommentsModal;
